export default __webpack_public_path__ + "static/media/icon-team-nomi.fdc77e9d.svg";